export default __webpack_public_path__ + "low-battery-icon.png";